---
meta:
  - title: Conexiones MCP - IUSPRO Docs
  - description: Entienda para qué sirve MCP en IUSPRO y cómo conectarlo con otras aplicaciones.
---

# Conexiones MCP

<a href="/settings/mcp" target="_blank">
	Ir a MCP →
</a>

MCP le permite conectar IUSPRO con otras aplicaciones compatibles, como Claude Desktop, TypingMind u otras herramientas de trabajo.

## ¿Para qué sirve?

MCP funciona como un puente entre IUSPRO y otra app.

Eso significa que puede usar esa otra aplicación para:

- Consultar la biblioteca legal de IUSPRO
- Hacer búsquedas legales desde una app externa
- Aprovechar su cuenta de IUSPRO sin salir de su flujo de trabajo habitual

En términos simples: MCP hace que otra app pueda consultar información de IUSPRO de forma autorizada.

## Cuándo le conviene usarlo

Esta opción es útil si usted ya trabaja en una herramienta externa y quiere conectarla con IUSPRO, en vez de entrar siempre directamente a la plataforma.

Si usa IUSPRO normalmente desde la web, no necesita configurar MCP.

## Cómo configurarlo

1. Haga clic en su **nombre o email** en la esquina inferior izquierda
2. Entre a **Preferencias**
3. Abra la pestaña **MCP**
4. Copie el **endpoint MCP**
5. Pegue ese endpoint en la aplicación que quiera conectar
6. Autentíquese con **OAuth** o con una **llave API**, según lo que soporte esa app

## OAuth o llave API

Algunas aplicaciones permiten conectarse con OAuth. En ese caso, solo debe agregar el endpoint y autorizar la conexión cuando IUSPRO se lo solicite.

Otras aplicaciones usan una llave API. En ese caso, debe generarla en la pantalla de MCP y copiarla en la app externa.

## Importante

- Las consultas hechas por MCP usan su cuenta de IUSPRO
- Esas consultas cuentan dentro de su uso normal
- Si cree que una llave fue expuesta, revóquela y genere una nueva
